<template>
	<div>
		<ProfileBlock>
			<FormulateForm v-model="form" @submit.prevent="login(form)">
				<FormulateInput
					type="text"
					required
					name="booking_reference"
					:validation-name="$t('login.booking_reference')"
					:placeholder="$t('login.booking_reference')"
					validation="required"
				></FormulateInput>
				<FormulateInput
					type="text"
					name="email_or_phone"
					required
					:validation-name="$t('login.email_or_phone')"
					:placeholder="$t('login.email_or_phone')"
					validation="required"
				></FormulateInput>
				<FormulateInput
					type="submit"
					class="w-full"
				>{{ $t('login.submit_button') }}</FormulateInput>
			</FormulateForm>
		</ProfileBlock>
	</div>
</template>

<script>
import {mapActions} from "vuex";
import ProfileBlock from "@/components/profile/ProfileBlock";

export default {
    name: "LoginForm",
    data() {
    	return {
            form: null
        }
    },
    methods: mapActions({"login": "auth/authWithCredentials"}),
    components: { ProfileBlock }
};
</script>

<style>
[data-view-type="profile"] .bb-view-background {

}
</style>
